"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserInfo = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const react_1 = require("react");
const data_1 = require("../assets/data");
const useUserInfo = () => {
    const colors = { moderator: '#FD960B', default: '#e60053' };
    const [info, setInfo] = (0, react_1.useState)(null);
    const [redirectUrl, setRedirectUrl] = (0, react_1.useState)(null);
    const getPayload = (0, react_1.useCallback)(() => {
        const token = localStorage.getItem("token");
        const payload = token ? (0, jwt_decode_1.default)(token) : null;
        return payload;
    }, []);
    const getChannelInfo = (0, react_1.useCallback)(() => {
        const channelId = document.getElementById("channelId");
        if (channelId == null) {
            return null;
        }
        return {
            id: channelId.value,
        };
    }, []);
    (0, react_1.useEffect)(() => {
        let payload = getPayload();
        const channelInfo = getChannelInfo();
        if (!channelInfo)
            return;
        if (payload == null) {
            payload = { username: "anonymous", email: "" };
        }
        // username = payload.username;
        fetch("/stream/user-info", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
                username: payload.username,
                email: payload.email,
                channelId: channelInfo.id,
            }),
        })
            .then((response) => response.json())
            .then((result) => {
            if ("redirectUrl" in result) {
                setRedirectUrl(result.redirectUrl);
            }
            else {
                setInfo(result);
            }
        })
            .catch((error) => console.log(error));
    }, [getPayload, getChannelInfo]);
    if (redirectUrl) {
        window.location.replace(redirectUrl);
    }
    if (!info)
        return null;
    return {
        ...info,
        color: info.isModerator ? colors.moderator : (0, data_1.getColor)(),
        role: info.isModerator ? 'moderator' : 'user',
        userIsLoggedIn: info.id != "anonymous",
    };
};
exports.useUserInfo = useUserInfo;
